import {BrowserRouter as Router, Route, Switch, Redirect} from "react-router-dom";
import { useRef, useEffect } from "react";
import Home from "routes/Home";
import TV from "routes/Tv";
import Search from "routes/Search"
import Detail from "routes/Detail"
import Header from "components/Header";
import {gsap} from "gsap";

export default () => {
    let test = useRef(null);
    useEffect(() => {
        
    })
    return (
        <>
            <Router>
                <Header />
                <Switch >
                    <Route exact={true} path="/" component={Home} />
                    <Route  path="/tv" component={TV} />
                    <Route  path="/search" component={Search} />
                    <Route  path="/movie/:id" component={Detail} />
                    <Route  path="/show/:id" component={Detail} />
                    <Redirect from="*" to="/" />
                </Switch>
            </Router>
        </>

    );

}